export default __webpack_public_path__ + "static/media/Screenshot_17.24931244.png";